export default class Translate {
  constructor(element) {
    this.element = element;
    this.init();
  }

  init() {
    const enContainers = document.querySelectorAll('.en-translate');
    for (let i = 0; i < enContainers.length; i++) {
      this.enableTranslation();
    }

    const path = window.location.pathname;

    const frenchPath = path.replace('-en.html', '.html');
    const englishPath = path.includes('-en.html')
      ? path
      : path.replace('.html', '-en.html');

    // Set all French buttons
    document.querySelectorAll('.lang-fr').forEach((button) => {
      button.href = frenchPath;
    });

    // Set all English buttons
    document.querySelectorAll('.lang-en').forEach((button) => {
      button.href = englishPath;
    });
  }

  enableTranslation() {
    document.querySelector('.js-index').href = 'index-en.html';

    const aboutLinks = document.querySelectorAll('.js-about');
    for (let i = 0; i < aboutLinks.length; i++) {
      const aboutLink = aboutLinks[i];
      aboutLink.innerHTML = 'About';
      aboutLink.href = 'about-en.html';
    }

    const projectsLinks = document.querySelectorAll('.js-projects');
    for (let i = 0; i < projectsLinks.length; i++) {
      const projectsLink = projectsLinks[i];
      projectsLink.innerHTML = 'Projects';
      projectsLink.href = 'projects-en.html';
    }

    const contactLinks = document.querySelectorAll('.js-contact');
    for (let i = 0; i < contactLinks.length; i++) {
      const contactLink = contactLinks[i];
      contactLink.innerHTML = 'Contact';
      contactLink.href = 'contact-en.html';
    }
  }
}
